// extracted by mini-css-extract-plugin
export default {"author":"ssEQ3__author theme-accent-border","date":"PDtav__date","menu":"j6IS1__menu","comment":"ATt5r__comment","addComment":"Sso0m__addComment"};